import { useUniqueInlineId } from '@inline-svg-unique-id/react'
import React from 'react'
import { SVGIconProps } from '../types'
const SvgKingAir350Er = function ({ size = 16, ...props }: SVGIconProps) {
  const _id = useUniqueInlineId()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width={size}
      height={size}
      viewBox="0 0 200 50"
      fill="currentColor"
      {...props}
    >
      <defs>
        <path
          id={_id}
          d="M3.488 0H30.49l.095.002c1.217.044 6.167.856 6.167 1.85 0 1.01-5.093 1.832-6.217 1.854h-.182l7.854 8.638c3.142 3.445 6.167 6.746 6.78 7.358 1.289 1.287 2.575 1.052 2.712 1.023l.012-.003 51.546 2.23q.44-.015.877-.026l-1.228-3.224h2.317l2.393 3.15q1.08-.015 2.142-.019h.707l20.989-.001-1.715-6.727h3.102l3.428 6.727h25.555c3.583 0 5.658.988 6.445 1.458l.077.047-.008.005.12.077q.087.058.125.087l3.26 2.564c.825.65 1.649 1.303 2.255 1.788l.735.593.016.01-1.41.846c-.088.061-.797.535-1.532.397.723.15 1.429-.303 1.551-.386l.02-.014 1.4-.836c.985.786 3.506 1.463 4.331 1.67l.266.064.419.089c13.632 2.909 23.159 6.728 24.036 9.415l.024.08q.045.159.046.313c0 4.812-26.316 8.713-58.779 8.713l-1.234-.002v.002h-45.43l-.291.004c-4.84.038-13.705-1.356-23.794-3.338a1123 1123 0 0 1-18.088-2.516l-1.272 3.694-21.677-1.826-2.882-5.89-4.027-.671-2.075-4.297-.576-.146-.93-1.848.496-.095L5.343 3.707H3.488C2.464 3.707 0 2.877 0 1.852 0 .85 2.373.031 3.43.001z"
        />
      </defs>
      <use xlinkHref={`#${_id}`} fill="#3E5667" fillRule="evenodd" />
    </svg>
  )
}
export default SvgKingAir350Er
